import { selectPlayerProfilePictureName } from "../balancingSelectors/selectBalancingPictures";
import { IdLeagues } from "../constants/IdLeagues";
import { EventType } from "../features/balancing/types/BalancingCore";
import { selectCoopInfo } from "./selectCoopInfo";
export var selectPlayerInfo = function (state) {
    return state.playerInfo;
};
export var selectPlayerName = function (state) {
    return {
        name: state.playerInfo.name,
    };
};
export var selectOwnPlayerProfileInfo = function (state) {
    var playerInfo = selectPlayerInfo(state);
    var playerId = playerInfo.playerId, name = playerInfo.name, level = playerInfo.level, profilePictureId = playerInfo.profilePictureId;
    var profileIcon = selectPlayerProfilePictureName(profilePictureId) || "";
    var playerLeagueInfo = state.leagueInfo.leagues.get(EventType.PlayerLeague);
    var playerLeagueId = playerLeagueInfo !== undefined && playerLeagueInfo.leagueId !== undefined
        ? playerLeagueInfo.leagueId
        : IdLeagues.Bronze1;
    var coopInfo = selectCoopInfo(state);
    if (coopInfo) {
        var coopLeagueInfo = state.leagueInfo.leagues.get(EventType.CoopLeague);
        coopInfo.coopLeagueId =
            coopLeagueInfo !== undefined && coopLeagueInfo.leagueId !== undefined
                ? coopLeagueInfo.leagueId
                : IdLeagues.Bronze1;
    }
    return {
        coopInfo: coopInfo,
        id: playerId,
        level: level,
        name: name,
        playerLeagueId: playerLeagueId,
        profileIcon: profileIcon,
    };
};
export var selectOwnPlayerId = function (state) {
    return selectPlayerInfo(state).playerId;
};
export var selectPlayerRemainingProbationTime = function (state) {
    return state.coopInfo.coopProjectAccessTime;
};



//////////////////
// WEBPACK FOOTER
// ./src/selectors/selectPlayerInfo.ts
// module id = 23
// module chunks = 3